export const KEEP_PLAYING = "KEEP_GOING";
export const LOAD_GAME = "LOAD_GAME";
export const MOVE = "MOVE";
export const NEW_GAME = "NEW_GAME";
